import { VendorPaymentEntity } from '@resident-select/domain/vendor-payment';
import { BookingEntity } from '@resident-select/domain/booking';
import { createAction, props } from '@ngrx/store';

export const GotAllVendorPaymentByVendorIdEvent = createAction('GotAllVendorPaymentByVendorIdEvent', props<{ entities: VendorPaymentEntity[] }>());

export const CreatedVendorPaymentEvent = createAction('CreatedVendorPaymentEvent', props<{ entities: VendorPaymentEntity[] }>());

export const GotAllBookingsByVendorAndStatusEvent = createAction('GotAllBookingsByVendorAndStatusEvent', props<{ entities: BookingEntity[] }>());

export const GotBookingsByVendorPaymentIdByDateRangeEvent = createAction('GotBookingsByVendorPaymentIdByDateRangeEvent', props<{ entities: BookingEntity[] }>());
